import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const BodyContainer = styled.div``;

const Container = styled.div``;

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;
const ValueSpanp = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;
const ValueSpan = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const TableContainer = styled.div`
  margin-top: 10px;
`;

const PopoverSpan = styled.span`
  background-color: #f3f3f3;
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 15px;
  cursor: pointer;
  margin: 5px 0px 5px 0px;
  background-color: #f3f3f3;
`;

const SC = {
  Container,
  BodyHeader,
  BodyContainer,
  HeadingTag,
  ValueSpan,
  MoreVertIcon,
  PopoverSpan,
  PopoverContainer,
  ValueSpanp,
  TableContainer,
};

export default SC;
